import Network from './network';

export default {
  getAll(args) {
    Network.get('/upcoming_new_hires', args);
  },
};
